import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import moment from "moment-timezone";

import DatepickerStateful from "./DatepickerStateful";

/*
Component
*/

const DatepickerContainer = (props) => {
  const { dispatchReceiveDateRange, insertId, timeEnd, timeStart } = props;

  const [dateRange, setDateRange] = useState({
    timeEnd: "",
    timeStart: "",
  });

  useEffect(() => {
    setDateRange({
      timeEnd: moment(timeEnd),
      timeStart: moment(timeStart),
    });
  }, [timeEnd, timeStart]);

  // Submit the dates
  const onClose = ({ range, changed }) => {
    if (!changed) {
      return;
    }

    const { rangeEnd, rangeStart } = range;

    dispatchReceiveDateRange({
      dateRange: {
        timeEnd: rangeEnd,
        timeStart: rangeStart,
      },
      insertId,
    });
  };

  return (
    <div>
      <DatepickerStateful
        onClose={onClose}
        timeEnd={dateRange.timeEnd}
        timeStart={dateRange.timeStart}
      />
    </div>
  );
};

DatepickerContainer.propTypes = {
  dispatchReceiveDateRange: PropTypes.func.isRequired,
  insertId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
  timeEnd: PropTypes.shape({}).isRequired,
  timeStart: PropTypes.shape({}).isRequired,
};

DatepickerContainer.defaultProps = {};

const makeMapStateToProps = (_, { intervalSelector, itemIdSelector }) => {
  const mapStateToProps = (state) => {
    const insertId = itemIdSelector(state);

    const selectedInterval = intervalSelector(state);

    const { dateRange = {} } = selectedInterval;
    const { timeEnd, timeStart } = dateRange;

    return {
      insertId,
      timeEnd,
      timeStart,
    };
  };

  return mapStateToProps;
};

const makeMapDispatchToProps = (_, { receiveDateRange }) => {
  const mapDispatchToProps = (dispatch) => ({
    dispatchReceiveDateRange: ({ dateRange, insertId }) => {
      dispatch(
        receiveDateRange({
          dateRange,
          insertId,
        })
      );
    },
  });

  return mapDispatchToProps;
};

export default connect(
  makeMapStateToProps,
  makeMapDispatchToProps
)(DatepickerContainer);
